import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { Wand2, Network, FileCheck, FileSpreadsheet } from 'lucide-react';
const features = [{
  title: 'From transcript to SOW',
  description: 'Upload call transcripts and automatically generate detailed Statements of Work, broken down by phase, module, and effort.',
  icon: <Wand2 className="h-6 w-6 text-primary-blue" data-id="element-216" />
}, {
  title: 'Auto-generated data imports',
  description: "Generate filled out data import templates based on transcripts, formatted exactly for your client's ERP system.",
  icon: <FileSpreadsheet className="h-6 w-6 text-primary-blue" data-id="element-217" />
}, {
  title: 'Client system map',
  description: 'Track ERP instances, add-ons, integrations, environments, and owners for each client in one view.',
  icon: <Network className="h-6 w-6 text-primary-blue" data-id="element-218" />
}, {
  title: 'Documentation & tests',
  description: 'Centralize design docs, test scripts, run results, and sign‑offs with full audit history.',
  icon: <FileCheck className="h-6 w-6 text-primary-blue" data-id="element-219" />
}];
export function ValueCards() {
  return <section className="py-24 bg-white" data-id="element-220">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-221">
        <div className="text-center mb-16" data-id="element-222">
          <h2 className="text-3xl font-bold text-slate-900 sm:text-4xl" data-id="element-223">
            Everything you need to deliver perfect projects.
          </h2>
          <p className="mt-4 text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-224">
            Purpose-built tools for the modern ERP consultancy.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-225">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-226">
              <Card className="h-full hover:border-primary-cyan/30 hover:shadow-lg hover:shadow-primary-blue/5 transition-all duration-300" data-id="element-227">
                <div className="h-12 w-12 bg-gradient-to-br from-primary-purple/10 to-accent/10 rounded-lg flex items-center justify-center mb-6" data-id="element-228">
                  {feature.icon}
                </div>
                <h3 className="text-lg font-semibold text-slate-900 mb-3" data-id="element-229">
                  {feature.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-230">
                  {feature.description}
                </p>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}